export const LEGAL_PRIVACY_POLICY_HEADING: string = `

<center>
 <h1 style="margin-bottom: 0">Datenschutzerklärung</h1>
 Ihre Datenschutzrechte
</center>

---

## Datenschutzerklärung

*Gültig ab dem 19. November 2024*
`;
